window.BAO.HideableStickyHeader = class HideableStickyHeader extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.onScroll = this.onScroll.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
  }

  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 150
    this.safeZone = 250
    this.scrollDirection = 'down'
    this.body = window.BAO.Utils.getElement('body')

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'scroll', this.onScroll, { passive: true })
    this.listeners.add(window, 'mousemove', this.onMouseMove, { passive: true })
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'
    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  elementIsSticky () {
    const header = window.BAO.Utils.getElement('.clc-ProductGrid_Header')
    if (!header) return

    const isSticky = header.getBoundingClientRect()
    if (!isSticky) return

    return isSticky.top === 0
  }

  onMouseMove (e) {
    if (this.visible) return
    if (this.sticky === false) return
    if (this.elementIsSticky()) return

    if (e.y <= this.offsetHeight + this.scrollOffset) {
      this.sticky = true
      this.visible = true
    }
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.sticky = this.shouldBeSticky
    this.visible = this.shouldBeVisible
  }

  get shouldBeSticky () {
    return this.lastKnownY >= this.safeZone
  }

  get shouldBeVisible () {
    if (this.lastKnownY < this.safeZone * 3) {
      return false
    }
    if (this.scrollDirection === 'down') {
      return !this.isOverOffset
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }

  get sticky () {
    return this.dataset.sticky === 'true'
  }

  set sticky (val) {
    this.dataset.sticky = val.toString()
  }

  get visible () {
    return this.dataset.visible === 'true'
  }

  set visible (val) {
    this.dataset.visible = val.toString()

    this.body.classList.toggle('lyt-Theme-headerVisible', val)
  }
}
